let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_NOTIFICATION": "Add Notification",
    "LBL_VIEW_NOTIFICATION": "View Notification",
    "LBL_NOTIFICATION_NAME": "Notification Name",
    "LBL_CREATED_BY": "Created By",
    "LBL_READ": "Read",
    "LBL_PARENT_ID": "Parent ID",
    "LBL_PARENT_TYPE": "Parent Type",
    "LBL_DESCRIPTION":"Message",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
    "LBL_SEND_BY":"Send By",
    "LBL_DATE":"Date",
    "LBL_RELETED":"Related",
    "LBL_READ":"Read",
    "LBL_DETAIL":"Details",
    "LBL_MARK_READ":"Mark As Read",
}

export default language;